import * as Common_pb from "../proto/Common_pb";
import * as User_pb from "../proto/User_pb";

import { UserServicesClient } from "../proto/WebServicesServiceClientPb";
import { RpcError } from "grpc-web";
const userServicesClient = new UserServicesClient(`${process.env.REACT_APP_PUBLIC_API_HOST}`);

export async function addUserChildApi(token:string , model:User_pb.UserChildModel | undefined ){
    const req = new User_pb.AddUserChildRequest();
    req.setModel(model);
    try{
        return await userServicesClient.addUserChild(req,{"authorization":token})
    }catch(err){
        return err as RpcError;
    }
}

export async function updateUserChildApi(token:string , model:User_pb.UserChildModel | undefined ){
    const req = new User_pb.UpdateUserChildRequest();
    req.setModel(model);
    try{
        return await userServicesClient.updateUserChild(req,{"authorization":token})
    }catch(err){
        return err as RpcError;
    }
}


export async function getUserChildListApi(token:string , pageinfo:Common_pb.PageInfoRequest | undefined):Promise<User_pb.GetUserChildListReply | RpcError> {
    const req = new User_pb.GetUserChildListRequest();
    req.setPageinfo(pageinfo);
    try{
        return await userServicesClient.getUserChildList(req,{"authorization":token})
    }catch(err){
        return err as RpcError;
    }
}


export async function deleteUserChildApi(token:string , model:User_pb.UserChildModel | undefined){
    const req = new User_pb.DeleteUserChildRequest();
    req.setModel(model);
    try{
        return await userServicesClient.deleteUserChild(req,{"authorization":token})
    }catch(err){
        return err as RpcError;
    }
}


export async function changePasswordApi(token:string , oldPassword:string , newPassword:string ){
    const req = new User_pb.ChangePasswordRequest();
    req.setOldPassword(oldPassword).setNewPassword(newPassword);
    try{
        return await userServicesClient.changePassword(req,{"authorization":token})
    }catch(err){
        return err as RpcError;
    }
}


export async function forgotPasswordApi(email:string){
    const req = new User_pb.ForgotPasswordRequest();
    req.setEmail(email);
    try{
        return await userServicesClient.forgotPassword(req, null)
    }catch(err){
        return err as RpcError;
    }
}


export async function updateUserProgramApi(token:string , programId:string){
    const req = new User_pb.UpdateUserProgramRequest();
    req.setProgramId(programId);
    try{
        return await userServicesClient.updateUserProgram(req,{"authorization":token})
    }catch(err){
        return err as RpcError;
    }
}